

















































































































































































































































































import IOutboundDeliveryNotes from '@/store/models/IOutboundDeliveryNotes';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import OutboundDeliveryNotesDetailSelector from '@/components/selectors/Outbounds/OutboundDeliveryNoteDetailSelector.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
import IWarehouse from '@/store/models/IWarehouse';
import IOutbound from '@/store/models/IOutbound';
import moment from 'moment';
import IStock from '@/store/models/IStock';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import IListPalletType from '@/store/models/IListPalletType';
import IGood from '@/store/models/IGood';
import OutbounDeliveryNotesDetailApi from '@/store/api/OutboundDeliveryNotesDetailApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import IListDock from '@/store/models/IListDock';
import { EMPTY_GUID, EMPTY_DOCK_GUID } from '@/config/constants';

@Component({
    components: {
        OutboundDeliveryNotesDetailSelector,
        Snackbar
    }
})
export default class OutboundDeliveryNotesSelector extends Vue {
    menu2: boolean = false;
    searchOutboundDeliveryNotes: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'code';
    sortDesc: boolean = false;
    selectedFormatToPrint: string = "excel";
    dialogPrinting: boolean = false;
    editedIndex : number = -1;
    editedItem : IOutboundDeliveryNotes = {
        id: "",
        idOutbound: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateOut: new Date(),
        description: "",
        statusName: "",
        idStatus: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }
    defaultItem : IOutboundDeliveryNotes = {
        id: "",
        idOutbound: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateOut: new Date(),
        description: "",
        statusName: "",
        idStatus: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }

    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesList !: IOutboundDeliveryNotes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop()
    SelectedOutbound !: IOutbound;
    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesDetailList !: IOutboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    CustomerStockDeliveryNoteDetail !: IStock[];
    @Prop({ type: Array, required: true })
    OutboundDetails !: IOutboundDetail[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop({ type: Array, required: true })
    PalletTypesList !: IListPalletType[];
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedOutbounds !: boolean;
    @Prop({ type: Boolean, default: false })
    IsSelectedWarehouseShared !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive!: boolean;
    @Prop({ type: Array, required: true })
    ListDocks !: IListDock[];
    @Prop()
    value !: IOutboundDeliveryNotes;
    
    selectedOutboundDeliveryNotes : IOutboundDeliveryNotes[] = [];
    selectedWarehouse : IWarehouse = {} as IWarehouse;
    selectedCompanySource : ICompany = {} as ICompany;
    selectedCompanyDestination : ICompany = {} as ICompany;
    dateOut: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
    canChangeWarehouse: boolean = true;
    selectedDock: IListDock = {} as IListDock;
    overlayDeliveryNoteDetail: boolean = false;
    
    get headers() {
        const baseHeaders = [
            { text: 'Company source', align: 'start', value: 'companySourceName' },
            { text: 'Company destination', value: 'companyDestinationName' },
            { text: 'Warehouse', value: 'warehouseName' }
        ];

        if (this.ScannerActive) {
            baseHeaders.push({ text: 'Dock', value: 'dockName' });
        }

        baseHeaders.push(
            { text: 'Customer', value: 'customerName' },
            { text: 'Code Delivery Note', value: 'code' },
            { text: 'Dossier Number Source', value: 'codeSource' },
            { text: 'Dossier Number Destination', value: 'codeDestination' },
            { text: 'Date Out', value: 'dateOut' },
            { text: 'Description', value: 'description' },
            { text: 'Status', value: 'statusName' }
        );

        if (this.ScannerActive) {
            baseHeaders.push({ text: 'Picked', value: 'dockPicked' });
        }

        baseHeaders.push({ text: 'Actions', value: 'actions' });

        return baseHeaders;
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Delivery Notes' : 'Edit Delivery Notes'; }

    get DateOutFormatted() {
        return this.formatDate(this.dateOut);
    }

    get minDate() {
        if (this.SelectedOutbound) {
            const d = new Date(this.SelectedOutbound.dateOut);
            d.setMonth(d.getMonth() - 1);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        }
        return this.dateOut;
    }

    get canEdit() {
        return this.OutboundDeliveryNotesDetailList.length > 0;
    }

    get sortedWarehouseList() {
        return this.WarehouseList.slice().sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    get filteredDocks() {
        if (!this.selectedWarehouse) return [];
        return this.ListDocks.filter(d => d.idWarehouse === this.selectedWarehouse.id);
    }

    get canSelectWarehouse(): boolean {
        if (!this.editedItem || !this.editedItem.idWarehouse) {
            return true;
        }

        return this.WarehouseList.some(w => w.id === this.editedItem.idWarehouse);
    }

    get warehouseDisplayName(): string {
        return (this.editedItem && this.editedItem.warehouseName)
            ? this.editedItem.warehouseName
            : (this.selectedWarehouse && (this.selectedWarehouse as any).name)
                ? (this.selectedWarehouse as any).name
                : "";
    }

    get defaultDeliveryNoteCode(): string {
        if (!this.SelectedOutbound || !this.SelectedOutbound.id || !this.SelectedOutbound.code) {
            return "";
        }

        const currentNotes = (this.OutboundDeliveryNotesList || [])
        .filter(n => n.idOutbound === this.SelectedOutbound.id);

        const nextNumber = currentNotes.length + 1;

        return `${this.SelectedOutbound.code}-${String(nextNumber).padStart(2, '0')}`;
    }

    getStatus(status: string) {
        if (this.IsSelectedWarehouseShared) {
            return status;
        }
        return "";
    }

    HasRightModifyCompletedOutbounds() {
        if (!this.Permissions[0].isWritable || (this.SelectedOutbound.statusName === 'Completed' && !this.CanModifyCompletedOutbounds)) return false;
        return true;
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    @Watch('OutboundDeliveryNotesDetailList')
    onChangeOutboundDeliveryNotesDetailList() {
        this.canChangeWarehouse = this.OutboundDeliveryNotesDetailList.length > 0;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }
    
    @Watch('value')
    updateSelection(newValue : IOutboundDeliveryNotes | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedOutboundDeliveryNotes = [];
        } else {
            this.selectedOutboundDeliveryNotes = [newValue];
            this.$emit('outboundDeliveryNoteChanged', this.selectedOutboundDeliveryNotes[0]);
        }
    }

    @Watch('selectedWarehouse')
    onChangeSelectedWarehouse() {

    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedOutbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    ShowDeliveryNoteDetails() : boolean {
        if (Object.keys(this.selectedOutboundDeliveryNotes).length !== 0) {
            if (this.selectedOutboundDeliveryNotes.length === 1) {
                return this.IsSelectedWarehouseShared;
            }
        }
        return false;
    }

    resetOutboundDeliveryNotes() {
        this.selectedWarehouse = {} as IWarehouse;
        this.selectedOutboundDeliveryNotes = [];
        this.dateOut = moment(new Date(this.SelectedOutbound.dateOut)).format('YYYY-MM-DD');
        this.IsSelectedWarehouseShared = false;
        this.selectedDock = {} as IListDock;

        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.code = this.defaultDeliveryNoteCode;

        this.$emit('resetOutboundDeliveryNotes');
    }

    editOutboundDeliveryNotes(item: any, dbox = true) {
        if (this.selectedOutboundDeliveryNotes.length > 0) {
            this.editedIndex = this.OutboundDeliveryNotesList.indexOf(item);
            this.editedItem = Object.assign({}, item);

            const warehouseFound = this.WarehouseList.find(p => p.id === this.editedItem.idWarehouse);

            if (warehouseFound) {
                this.selectedWarehouse = warehouseFound;
                this.editedItem.idWarehouse = warehouseFound.id;
                this.editedItem.warehouseName = warehouseFound.name;
            } else {
                this.selectedWarehouse = {
                    id: this.editedItem.idWarehouse,
                    name: this.editedItem.warehouseName
                } as IWarehouse;
            }

            this.dateOut = moment(new Date(item.dateOut)).format('YYYY-MM-DD');

            this.selectedDock = this.ListDocks.find(d => d.id === this.editedItem.idDock) || ({} as IListDock);

            this.canChangeWarehouse = this.OutboundDeliveryNotesDetailList.length > 0;

            this.dialog = true;
        }
    }

    saveOutboundDeliveryNotes () {
        if (this.SelectedOutbound.statusName === 'Completed' && this.CanModifyCompletedOutbounds === false) {
            this.close();
        } else {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                if (this.editedItem.code === "" && this.IsSelectedWarehouseShared) {
                    this.showMessageWarning('Code must be filled out.');
                    return;
                }
                this.editedItem.dateOut = new Date(this.dateOut);
                this.editedItem.idCompanySource = this.SelectedOutbound.idCompanySource;
                this.editedItem.companySourceName = this.SelectedOutbound.companySourceName;
                
                // 🚨 Gestión de docks
                if (!this.ScannerActive) {
                    // Cliente sin licencia de Docks → asignar Dock Unknown
                    this.editedItem.idDock = EMPTY_GUID;
                    this.editedItem.dockName = "Dock Unknown";
                } else {
                    if (!this.IsSelectedWarehouseShared) {
                        if (!this.selectedDock || !this.selectedDock.id) {
                            this.showMessageWarning('Dock must be filled out.');
                            return; // 🚨 salir sin salvar
                        }
                        this.editedItem.idDock = this.selectedDock.id;
                        this.editedItem.dockName = this.selectedDock.name;
                    } else {
                        if (!this.selectedDock || !this.selectedDock.id) {
                            this.editedItem.idDock = EMPTY_DOCK_GUID;
                            this.editedItem.dockName = "Dock Unknown";
                        } else {
                            this.editedItem.idDock = this.selectedDock.id;
                            this.editedItem.dockName = this.selectedDock.name;
                        }
                    }
                }

                if (this.selectedOutboundDeliveryNotes.length > 0) {
                    this.close();
                    this.editedIndex = this.OutboundDeliveryNotesList.findIndex(o => o.id === this.selectedOutboundDeliveryNotes[0].id);
                    this.$emit('editOutboundDeliveryNotes', this.editedItem);
                    Object.assign(this.OutboundDeliveryNotesList[this.editedIndex], this.editedItem);
                } else {
                    this.editedItem.codeDestination = this.SelectedOutbound.codeDestination;

                    if (this.canSelectWarehouse) {
                        this.editedItem.idWarehouse = this.selectedWarehouse.id;
                        this.editedItem.warehouseName = this.selectedWarehouse.name;
                    }

                    this.editedItem.idCompanyDestination = this.SelectedOutbound.idCompanyDestination;
                    this.editedItem.companyDestinationName = this.SelectedOutbound.companyDestinationName;
                    this.editedItem.idCustomer = this.SelectedOutbound.idCustomer;
                    this.editedItem.customerName = this.SelectedOutbound.customerName;
                    this.editedItem.idOutbound = this.SelectedOutbound.id;

                    if (this.editedItem.code === "") {
                        this.editedItem.code = this.defaultDeliveryNoteCode;
                    }

                    this.editedItem.codeSource = this.SelectedOutbound.code;
                    this.selectedOutboundDeliveryNotes[0] = this.editedItem;
                    this.$emit('saveOutboundDeliveryNotes', this.editedItem);
                }
            } else {
                this.showMessageWarning('All required fields must be filled out');
            }
        }
    }

    deleteOutboundDeliveryNotes (outboundDeliveryNotes: IOutboundDeliveryNotes) {
        if (this.selectedOutboundDeliveryNotes.length > 0) {
            this.$emit('deleteOutboundDeliveryNotes', outboundDeliveryNotes);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    getCustomerStockFiltered() {
        this.editedItem.idWarehouse = this.selectedWarehouse.id;
        this.editedItem.warehouseName = this.selectedWarehouse.name;
        this.$emit('getCustomerStockFiltered', this.editedItem);
    }

    async saveOutboundDeliveryNotesDetail(selectedStockCustomerToDelivery: IStock[]) {
        this.overlayDeliveryNoteDetail = true;
        let outboundDeliveryNotesDetailApi: OutbounDeliveryNotesDetailApi = new OutbounDeliveryNotesDetailApi();
        for (let stockCustomerToDelivery of selectedStockCustomerToDelivery) {
            let outboundDeliveryNoteDetail = this.createOutbounDeliveryNoteDetail(stockCustomerToDelivery);
            
            await outboundDeliveryNotesDetailApi.SaveOutboundDeliveryNotesDetail(outboundDeliveryNoteDetail);
        }
        this.overlayDeliveryNoteDetail = false;
        this.$emit('saveOutboundDeliveryNotesDetail', selectedStockCustomerToDelivery);
    }

    createOutbounDeliveryNoteDetail(stockCustomerToDelivery: IStock) : IOutboundDeliveryNotesDetail {
        let outboundDeliveryNoteDetail : IOutboundDeliveryNotesDetail = {} as IOutboundDeliveryNotesDetail;
        outboundDeliveryNoteDetail.idGood = stockCustomerToDelivery.idGood;
        outboundDeliveryNoteDetail.goodsPerCase = stockCustomerToDelivery.goodsPerCase;
        outboundDeliveryNoteDetail.totalGoods = stockCustomerToDelivery.totalGoods;
        outboundDeliveryNoteDetail.weight = stockCustomerToDelivery.weight;
        outboundDeliveryNoteDetail.bestBeforeDate = stockCustomerToDelivery.bestBeforeDate;
        outboundDeliveryNoteDetail.idOutboundDetail = stockCustomerToDelivery.idOutboundDetail;
        outboundDeliveryNoteDetail.goodName = stockCustomerToDelivery.goodName;
        outboundDeliveryNoteDetail.idListPallet = stockCustomerToDelivery.idListPallet;
        outboundDeliveryNoteDetail.palletName = stockCustomerToDelivery.listPalletName;
        outboundDeliveryNoteDetail.idPallet = stockCustomerToDelivery.idPallet;
        outboundDeliveryNoteDetail.casesPerPallet = stockCustomerToDelivery.totalCases;
        outboundDeliveryNoteDetail.totalCases = stockCustomerToDelivery.totalCases;
        outboundDeliveryNoteDetail.idOutboundDeliveryNote = this.selectedOutboundDeliveryNotes[0].id;
        
        return outboundDeliveryNoteDetail;
    }

    deleteOutboundDeliveryNotesDetail(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        this.$emit('deleteOutboundDeliveryNotesDetail', outboundDeliveryNotesDetail);
    }

    printOutboundDeliveryNotes() {
        this.dialogPrinting = false;
        this.$emit('printOutboundDeliveryNotes', this.selectedFormatToPrint);
    }

    select(item : IOutboundDeliveryNotes) : void {
        let index : number = this.selectedOutboundDeliveryNotes.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedOutboundDeliveryNotes = [item];
            this.$emit('input', item);
        } else {
            let outboundDeliveryNote = this.selectedOutboundDeliveryNotes.find(w => w.id === item.id);
            if (!outboundDeliveryNote) {
                this.selectedOutboundDeliveryNotes = [];
                this.$emit('input', null);
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
